import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { EnvelopeAccessLinkPasswordResponse } from './access-links.types'

export const ENVELOPE_ACCESS_LINK_PASSWORD_QUERY_KEY =
  'envelope-access-link-password'

const getEnvelopeAccessLinkPassword = async (
  envelopeId: string,
  linkId: string,
): Promise<EnvelopeAccessLinkPasswordResponse> => {
  const response = await apiClient.get<EnvelopeAccessLinkPasswordResponse>(
    `/v1/ecm/envelopes/${envelopeId}/access-links/${linkId}/password`,
  )
  return response.data
}

export const useGetEnvelopeAccessLinkPassword = (
  envelopeId: string,
  linkId: string | null,
) => {
  return useQuery({
    queryKey: [ENVELOPE_ACCESS_LINK_PASSWORD_QUERY_KEY, envelopeId, linkId],
    queryFn: () => getEnvelopeAccessLinkPassword(envelopeId, linkId ?? ''),
    enabled: linkId !== null,
    staleTime: Infinity,
    retry: false,
  })
}
